if (!customElements.get('pfd-demo')) {
  customElements.define('pfd-demo', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-demo-choice]');
        const interest = this.querySelector('[data-demo-interest]');
        if (!choice || !interest) return;
        interest.value = choice.dataset.demoChoice;
        interest.dispatchEvent(new Event('change', { bubbles: true }));
        interest.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
